var map = {
	"./all-africa.png": "68b3",
	"./burkina-faso.png": "125b",
	"./ethiopia.png": "3d4b",
	"./flag-kenya.png": "df71",
	"./flag-nigeria.png": "04b2",
	"./flag-south-africa.png": "2159",
	"./flag-southafrica-big.png": "9bcf",
	"./flag-southafrica-medium.png": "3c28",
	"./kenya.png": "ccda",
	"./nigeria.png": "e1df",
	"./south-africa.png": "17a2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "522f";